module.exports = __webpack_public_path__ + "img/LogoLoading_circle01.f5885005.png";